import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/entities")({
  beforeLoad: () => {
    throw redirect({ to: "/data" });
  },
  component: () => null,
});
